(() => {
if (window.SNTikTokFeed) { window.SNTikTokFeed.init(document); return; }
const requests = new Map(), queue = [];
const ttl = 30 * 60 * 1000;
let running = 0;
const key = url => `sn-tiktok-cover:${url}`;
const drain = () => {
while (running < 2 && queue.length) {
const task = queue.shift();
running++;
task().finally(() => { running--; drain(); });
}
};
const metadata = (url, refresh = false) => {
if (refresh) {
requests.delete(url);
try { sessionStorage.removeItem(key(url)); } catch (_) {}
}
const existing = requests.get(url);
if (existing && existing.expires > Date.now()) return existing.promise;
requests.delete(url);
try {
const cached = JSON.parse(sessionStorage.getItem(key(url)) || 'null');
if (cached?.savedAt && Date.now() - cached.savedAt < ttl) return Promise.resolve(cached);
} catch (_) {}
const promise = new Promise(resolve => {
queue.push(async () => {
const controller = typeof AbortController === 'function' ? new AbortController() : null;
const timeout = controller ? setTimeout(() => controller.abort(), 8000) : null;
try {
const response = await fetch(`https://www.tiktok.com/oembed?url=${encodeURIComponent(url)}`, {
mode: 'cors', credentials: 'omit', ...(controller ? { signal: controller.signal } : {})
});
if (!response.ok) throw new Error('metadata unavailable');
const data = await response.json();
const result = { thumbnail: data.thumbnail_url, author_name: data.author_name,
author_url: data.author_url, savedAt: Date.now() };
const pending = requests.get(url);
if (pending) pending.expires = Date.now() + ttl;
try { sessionStorage.setItem(key(url), JSON.stringify(result)); } catch (_) {}
resolve(result);
} catch (_) {
requests.delete(url);
resolve(null);
} finally { clearTimeout(timeout); }
});
drain();
});
requests.set(url, { promise, expires: Infinity });
return promise;
};
const safeProfile = value => {
try { const url = new URL(value); return url.protocol === 'https:' && /(^|\.)tiktok\.com$/.test(url.hostname) && /^\/@[^/]+\/?$/.test(url.pathname) ? url.href : ''; }
catch (_) { return ''; }
};
function init(root) {
if (root.dataset.snFeedReady) return;
root.dataset.snFeedReady = 'true';
const players = [...root.querySelectorAll('[data-sn-tiktok-player]')];
const rail = root.querySelector('[data-sn-tiktok-rail]');
const track = root.querySelector('[data-sn-tiktok-track]');
const thumb = root.querySelector('[data-sn-tiktok-thumb]');
let disposed = false, nearObserver, cardObserver, resizeObserver, frame;
let max = 0, travel = 0, trackRect, dragging = false;
const applyAuthor = (player, data) => {
const author = player.querySelector('[data-sn-tiktok-author]');
const url = safeProfile(data?.author_url);
if (!author || !url || !data?.author_name) return;
author.querySelector('[data-sn-tiktok-author-name]').textContent = data.author_name;
author.href = url;
author.hidden = false;
const card = player.closest('[data-sn-tiktok-card]');
card.querySelectorAll('[data-sn-tiktok-watch]').forEach(link => {
link.setAttribute('aria-label', `${link.dataset.snTiktokWatch} — ${data.author_name}`);
});
const play = player.querySelector('[data-sn-tiktok-play]');
if (play) play.setAttribute('aria-label', `${play.dataset.playLabel} — ${data.author_name}`);
};
const applyCover = (player, src) => {
if (!src || !/^https:\/\//i.test(src) || disposed || !player.isConnected) return;
const image = player.querySelector('[data-sn-tiktok-cover], .sn-tiktok-feed__cover');
if (!image || image.getAttribute('src') === src) return;
const fallback = { src: image.getAttribute('src'), srcset: image.getAttribute('srcset'), sizes: image.getAttribute('sizes') };
const failed = () => {
image.removeEventListener('load', loaded);
['src', 'srcset', 'sizes'].forEach(attr => fallback[attr] ? image.setAttribute(attr, fallback[attr]) : image.removeAttribute(attr));
if (player.dataset.coverRetried !== 'true') {
player.dataset.coverRetried = 'true';
metadata(player.dataset.tiktokUrl, true).then(data => apply(player, data));
}
};
const loaded = () => {
image.removeEventListener('error', failed);
image.hidden = false;
player.querySelector('.sn-tiktok-feed__placeholder > span')?.setAttribute('hidden', '');
};
image.addEventListener('load', loaded, { once: true });
image.addEventListener('error', failed, { once: true });
image.removeAttribute('srcset');
image.removeAttribute('sizes');
image.src = src;
};
const apply = (player, data) => {
if (!data || disposed || !player.isConnected) return;
applyAuthor(player, data);
applyCover(player, data.thumbnail);
};
const load = player => {
if (player.dataset.coverRequested || !player.dataset.tiktokUrl || disposed) return;
player.dataset.coverRequested = 'true';
metadata(player.dataset.tiktokUrl).then(data => apply(player, data));
};
players.forEach(player => {
try {
const url = new URL(player.dataset.tiktokUrl);
const handle = url.pathname.match(/^\/@([^/]+)\/video\//)?.[1];
if (handle) applyAuthor(player, { author_name: `@${handle}`, author_url: `https://www.tiktok.com/@${handle}` });
} catch (_) {}
});
const observeCards = () => {
if (cardObserver || disposed) return;
if (!('IntersectionObserver' in window)) { players.slice(0, 2).forEach(load); return; }
cardObserver = new IntersectionObserver(entries => entries.forEach(entry => {
if (entry.isIntersecting) { load(entry.target); cardObserver.unobserve(entry.target); }
}), { root: rail, rootMargin: '0px 350px' });
players.forEach(player => cardObserver.observe(player));
};
if ('IntersectionObserver' in window) {
nearObserver = new IntersectionObserver(entries => {
if (entries.some(entry => entry.isIntersecting)) { observeCards(); nearObserver.disconnect(); }
}, { rootMargin: '1000px 0px' });
nearObserver.observe(root);
} else observeCards();
const intent = event => {
const player = event.target.closest('[data-sn-tiktok-player]');
if (player) load(player);
};
root.addEventListener('pointerover', intent, { passive: true });
root.addEventListener('focusin', intent);
root.addEventListener('click', event => {
const trigger = event.target.closest('[data-sn-tiktok-play]');
if (!trigger) return;
const player = trigger.closest('[data-sn-tiktok-player]');
const video = player?.querySelector('[data-sn-hosted-video]');
if (!video || trigger.disabled) return;
document.querySelectorAll('[data-sn-hosted-video]').forEach(other => {
if (other !== video && !other.paused) other.pause();
});
trigger.disabled = true;
if (!video.dataset.hydrated) {
video.dataset.hydrated = 'true';
video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; source.removeAttribute('data-src'); });
video.load();
}
player.classList.add('is-hosted-active');
video.play()?.catch(() => { trigger.disabled = false; video.controls = true; });
});
const onPlay = event => {
if (!event.target.matches('[data-sn-hosted-video]') || event.target.paused) return;
document.querySelectorAll('[data-sn-hosted-video]').forEach(video => {
if (video !== event.target && !video.paused) video.pause();
});
};
root.addEventListener('play', onPlay, true);
players.forEach(player => player.querySelector('video')?.addEventListener('error', () => {
player.classList.remove('is-hosted-active');
const trigger = player.querySelector('[data-sn-tiktok-play]');
if (trigger) trigger.disabled = false;
}));
const onVisibility = () => {
if (document.hidden) players.forEach(player => player.querySelector('video')?.pause());
};
document.addEventListener('visibilitychange', onVisibility);
const paint = () => {
frame = null;
if (thumb) thumb.style.transform = `translateX(${max ? Math.min(1, Math.abs(rail.scrollLeft) / max) * travel : 0}px)`;
};
const schedule = () => { if (!frame) frame = requestAnimationFrame(paint); };
const measure = () => {
if (!rail || !track || !thumb) return;
const width = rail.clientWidth, total = rail.scrollWidth, trackWidth = track.clientWidth;
max = Math.max(0, total - width);
const thumbWidth = Math.max(12, Math.min(1, total ? width / total : 1) * 100);
travel = trackWidth * (1 - thumbWidth / 100);
thumb.style.width = `${thumbWidth}%`;
schedule();
};
const onKey = event => {
if (event.target !== rail || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
event.preventDefault();
if (event.key === 'Home' || event.key === 'End') rail.scrollTo({ left: event.key === 'Home' ? 0 : rail.scrollWidth, behavior: 'smooth' });
else rail.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * rail.clientWidth * .8, behavior: 'smooth' });
};
rail?.addEventListener('keydown', onKey);
rail?.addEventListener('scroll', schedule, { passive: true });
const seek = event => {
if (!trackRect?.width) return;
rail.scrollTo({ left: Math.max(0, Math.min(1, (event.clientX - trackRect.left) / trackRect.width)) * max, behavior: 'auto' });
};
track?.addEventListener('pointerdown', event => { dragging = true; trackRect = track.getBoundingClientRect(); track.setPointerCapture?.(event.pointerId); seek(event); });
track?.addEventListener('pointermove', event => { if (dragging) seek(event); });
['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => track?.addEventListener(type, () => { dragging = false; }));
if ('ResizeObserver' in window && rail) { resizeObserver = new ResizeObserver(measure); resizeObserver.observe(rail); }
else window.addEventListener('resize', measure, { passive: true });
measure();
const unload = event => {
if (!event.target.contains(root)) return;
disposed = true;
nearObserver?.disconnect(); cardObserver?.disconnect(); resizeObserver?.disconnect();
cancelAnimationFrame(frame);
players.forEach(player => player.querySelector('video')?.pause());
window.removeEventListener('resize', measure);
document.removeEventListener('visibilitychange', onVisibility);
document.removeEventListener('shopify:section:unload', unload);
};
document.addEventListener('shopify:section:unload', unload);
}
const initAll = (scope = document) => {
if (scope.matches?.('[data-sn-tiktok-feed]')) init(scope);
scope.querySelectorAll('[data-sn-tiktok-feed]').forEach(init);
};
window.SNTikTokFeed = { init: initAll };
initAll();
document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
